import { toast, Zoom } from 'react-toastify';

export const defaultToastConfig = {
  position: toast.POSITION.TOP_RIGHT,
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  transition: Zoom,
};
